"use client";

import { useActionState } from "react";
import { ConsentCheckboxes, DIGITAL_CONTENT_WITHDRAWAL_LABEL } from "@/app/checkout-consent";
import { checkoutTour } from "../checkout/actions";

export function BuyButton({ tourId }: { tourId: string }) {
  const action = checkoutTour.bind(null, tourId);
  const [error, formAction, pending] = useActionState(action, undefined);

  return (
    <form action={formAction} className="space-y-4">
      <ConsentCheckboxes withdrawalLabel={DIGITAL_CONTENT_WITHDRAWAL_LABEL} />

      {error && (
        <p className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700" role="alert">
          {error}
        </p>
      )}
      <button
        type="submit"
        disabled={pending}
        className="inline-flex items-center justify-center gap-2 rounded-full bg-[#e8607a] px-8 py-3.5 text-sm font-bold uppercase tracking-widest text-white shadow-md transition-all hover:-translate-y-0.5 hover:bg-[#d4556e] disabled:pointer-events-none disabled:opacity-60"
      >
        {pending ? "Przekierowywanie…" : "Kup teraz"}
      </button>
    </form>
  );
}
